<template>
  <!-- START: No shopping list -->
  <div class="d-flex flex-column text-center mt-4">
    <!-- Shopping list instruction -->
    <p class="wc-barcode-instruction font-weight-bold">
      {{ $t('shopFromASavedList') }}
    </p>

    <!-- Shopping list selection -->
    <h1 class="mb-3" v-if="shoppingList && shoppingList.length">
      <WCSelect
        :aria-label="$t('selectShoppingList')"
        class="mb-3 border-primary btn text-primary rounded w-50 wc-select-min-width"
        v-model="listId"
        @input="selectedShoppingLists()"
      >
        <option value="">{{ $t('selectShoppingList') }}</option>
        <option v-for="list in shoppingList" :key="list.id" :value="list.id">
          {{ list.name }}
        </option>
      </WCSelect>
    </h1>

    <!-- Manage saved list routing -->
    <div class="d-flex justify-content-center">
      <router-link
        class="underline-link-from-center"
        to="/me/lists"
        v-if="$configuration.listEnabled"
        :aria-label="$t('manageSavedList')"
      >
        {{ $t('manageYourSavedList') }}
      </router-link>
    </div>
  </div>
  <!-- END: No shopping list -->
</template>
<script>
import WCSelect from '@/modules/forms/components/WCSelect/WCSelect.vue';

export default {
  name: 'ScanNoShoppingListOverlayView',
  props: {
    shoppingList: {
      type: Array,
      required: true,
    },
  },
  components: {
    WCSelect,
  },
  data() {
    return {
      listId: '',
    };
  },
  methods: {
    /**
     * Method to select the shopping list
     */
    selectedShoppingLists() {
      if (!this.listId) return;
      const id = this.$route.params.id;
      if (id) {
        this.$router.push(`/scan/item/${id}/${this.listId}`);
      } else {
        this.$router.push(`/scan/list/${this.listId}`);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.wc-barcode-instruction {
  white-space: pre-wrap;
  font-weight: 400;
}

.wc-select-min-width {
  min-width: fit-content;
}
</style>
